import Component from '@glimmer/component';
import { service } from '@ember/service';
import { t, type IntlService } from 'ember-intl';
import { PhTimer } from 'ember-phosphor-icons';
import HeroStat from 'tio-employee/components/dashboard-kit/hero-stat';
import {
  RESPONSE_WINDOW_DAYS,
  type DecisionStats,
} from 'tio-employee/utils/partner-dashboard/sources/recent-decisions';
import type { WidgetComponentSignature } from 'tio-employee/utils/partner-dashboard/registry';

/** Hero tile: decisions the viewer made this week, and their median response time. */
export default class DecisionPaceWidget extends Component<WidgetComponentSignature<DecisionStats>> {
  @service declare intl: IntlService;

  get context() {
    const median = this.args.data.medianResponseDays;
    if (median === null) {
      return this.intl.t('partner_dashboard.pace.no_recent', { days: RESPONSE_WINDOW_DAYS });
    }
    const shown = Math.round(median * 10) / 10;
    return this.intl.t('partner_dashboard.pace.median', {
      median: this.intl.formatNumber(shown, { maximumFractionDigits: 1 }),
      count: shown,
      days: RESPONSE_WINDOW_DAYS,
    });
  }

  <template>
    <HeroStat
      @emphasis="metric"
      @label={{t "partner_dashboard.pace.decided_this_week"}}
      @value={{@data.decidedThisWeek}}
      @context={{this.context}}
      @contextIcon={{PhTimer}}
      data-test-partner-dashboard-decision-pace
    />
  </template>
}
